import type { Location } from "@/bryntum-lib/models/Location";

export function formatLocationLines(locationRecord: Location | null | undefined) {
  const cityLine = [
    locationRecord?.city,
    locationRecord?.stateOrRegion && locationRecord?.postalCode
      ? `${locationRecord.stateOrRegion} ${locationRecord.postalCode}`.trim()
      : (locationRecord?.stateOrRegion || locationRecord?.postalCode),
    locationRecord?.country,
  ]
    .filter(Boolean)
    .join(", ");

  const hasProperty = !!locationRecord?.propertyName;
  const heading = hasProperty
    ? locationRecord!.propertyName
    : (locationRecord?.streetAddress ?? "");

  const subLine = hasProperty
    ? [locationRecord?.streetAddress, cityLine].filter(Boolean).join(", ")
    : cityLine;

  const copyText = [locationRecord?.streetAddress, cityLine].filter(Boolean).join(", ");

  const lat = locationRecord?.latitude ?? null;
  const lon = locationRecord?.longitude ?? null;
  const hasCoords = lat !== null && lon !== null;

  return { heading, subLine, copyText, hasCoords, lat, lon };
}
